import * as yup from 'yup'

export const overAllDealsSummarySchema = yup.object().shape({
  year: yup.array().min(1, 'Select year').typeError('Select a year').required('Select a year'),
})
